import gql from 'graphql-tag';

const GET_PROJECT = gql`
  query($projectId: ID!, $isItProduct: Boolean!) {
    getProject(projectId: $projectId) {
      contract @skip(if: $isItProduct) {
        contractId
        billableContract {
          contractId
          chargeItem {
            itemId
            name
          }
        }
      }
      invoices @skip(if: $isItProduct) {
        invoiceId
        displayId
        createdTime
      }
      workItem {
        workId
        subject
        associations {
          workId
          displayId
          subject
          module
        }
      }
      projectId
      displayId
      title
      status
      scheduledStartDate
      dueDate
      overdue
      actualStartDate
      actualEndDate
      client {
        accountId
        name
      }
      site {
        id
        name
      }
      owner {
        userId
        name
        firstName
        lastName
        email
      }
      members {
        user {
          userId
          name
          firstName
          lastName
          email
        }
        totalTasks
        completedTasks
        type
      }
      milestones {
        milestoneId
        milestoneOrder
        name
        status
        totalTasks
        plannedTasks
        inProgressTasks
        blockedTasks
        completedTasks
        overdueTasks
      }
      totalTasks
      plannedTasks
      inProgressTasks
      blockedTasks
      completedTasks
      overdueTasks
      totalMilestones
      showToClient
      completedMilestones
      loggedInUserRole {
        roleId
        name
        description
        roleType {
          name
        }
        editable
        creationType
        roleFeatureList {
          feature {
            featureId
            key
          }
          operationList {
            operationId
            name
            value
          }
        }
      }
    }
  }
`;

const GET_PROJECTS = gql`
  query($listInfo: ListInfoInput!, $isItProduct: Boolean!) {
    getProjects(listInfo: $listInfo) {
      projects {
        createdTime
        projectId
        displayId
        title
        status
        scheduledStartDate
        dueDate
        overdue
        contract @skip(if: $isItProduct) {
          contractId
        }
        actualStartDate
        actualEndDate
        client {
          accountId
          name
        }
        site {
          id
          name
        }
        owner {
          userId
          name
          firstName
          lastName
          email
        }
        totalTasks
        plannedTasks
        inProgressTasks
        blockedTasks
        completedTasks
        overdueTasks
        totalMilestones
        completedMilestones
        loggedInUserRole {
          roleId
          name
          description
          roleType {
            name
          }
          editable
          creationType
          roleFeatureList {
            feature {
              featureId
              key
            }
            operationList {
              operationId
              name
              value
            }
          }
        }
      }
      listInfo {
        page
        pageSize
        condition
        totalCount
        hasMore
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_PROJECT_FEEDS = gql`
  query($projectId: ID!) {
    getProjectFeeds(projectId: $projectId) {
      type
      time
      conversation {
        conversationId
        content
        addedBy {
          userId
          name
          firstName
          lastName
          email
        }
        addedOn
        attachments {
          fileName
          originalFileName
          fileSize
        }
      }
      vendorConversation {
        type
        time
        user {
          userId
          firstName
          lastName
          email
        }
        workItem {
          workId
          module
          subject
          displayId
        }
        conversationId
        parentConversationId
      }
      milestone {
        milestoneId
        name
        status
        actualEndDate
        totalTasks
        plannedTasks
        inProgressTasks
        blockedTasks
        completedTasks
        overdueTasks
      }
      task {
        taskId
        displayId
        title
        description
        status
        estimatedTime
        scheduledStartDate
        dueDate
        technician {
          userId
          firstName
          lastName
          email
        }
        techGroup {
          groupId
          name
        }
      }
      note {
        noteId
        content
        addedBy {
          userId
          firstName
          lastName
        }
        addedOn
        attachments {
          fileName
          originalFileName
          fileSize
        }
        privacyType
      }
    }
  }
`;

const GET_PROJECT_CONVERSATIONS = gql`
  query($projectId: ID!) {
    getProjectConversations(projectId: $projectId) {
      conversationId
      content
      addedBy {
        userId
        name
        firstName
        lastName
        email
      }
      addedOn
      attachments {
        fileName
        originalFileName
        fileSize
      }
    }
  }
`;

const GET_PROJECT_CONVERSATIONS_LIST = gql`
  query getProjectConversationList($input: GetProjectConversationListInput!) {
    getProjectConversationList(input: $input) {
      projectConversations {
        conversationId
        content
        addedBy {
          userId
          name
          firstName
          lastName
          email
        }
        addedOn
        attachments {
          fileName
          originalFileName
          fileSize
        }
        project {
          projectId
          title
          createdTime
        }
      }
      listInfo {
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_PROJECT_FEED_LIST = gql`
  query getProjectFeedList($input: GetProjectFeedListInput!) {
    getProjectFeedList(input: $input) {
      projectFeeds {
        type
        time
        conversation {
          conversationId
          content
          addedBy {
            userId
            name
            firstName
            lastName
            email
          }
          addedOn
          attachments {
            fileName
            originalFileName
            fileSize
          }
        }
        vendorConversation {
          type
          time
          user {
            userId
            firstName
            lastName
            email
          }
          workItem {
            workId
            module
            subject
            displayId
          }
          conversationId
          parentConversationId
        }
        milestone {
          milestoneId
          name
          status
          actualEndDate
          totalTasks
          plannedTasks
          inProgressTasks
          blockedTasks
          completedTasks
          overdueTasks
        }
        task {
          taskId
          displayId
          title
          description
          status
          estimatedTime
          scheduledStartDate
          dueDate
          technician {
            userId
            firstName
            lastName
            email
          }
          techGroup {
            groupId
            name
          }
          workItem {
            workId
            module
          }
        }
        note {
          noteId
          content
          addedBy {
            userId
            firstName
            lastName
          }
          addedOn
          attachments {
            fileName
            originalFileName
            fileSize
          }
          privacyType
        }
      }
    }
  }
`;

const GET_PROJECT_VIEW_COUNT = gql`
  query getProjectViewsCount($viewIds: [ID]) {
    getProjectViewsCount(viewIds: $viewIds) {
      viewId
      count
    }
  }
`;

const GET_PROJECTS_LISTVIEW_META = gql`
  query {
    getProjectListViewMetaInfo
  }
`;

export {
  GET_PROJECT,
  GET_PROJECTS,
  GET_PROJECT_FEEDS,
  GET_PROJECT_CONVERSATIONS,
  GET_PROJECT_CONVERSATIONS_LIST,
  GET_PROJECT_FEED_LIST,
  GET_PROJECT_VIEW_COUNT,
  GET_PROJECTS_LISTVIEW_META
};

//unknown emails, Date format
